module.exports = "<div md-whiteframe=\"1\" class=\"content-box text-center\">\n    <p><div logo></div></p>\n    <h2>{{\"RESOURCE.VIEW_NOT_FOUND\" | translate}}</h2>\n  </div>";


//////////////////
// WEBPACK FOOTER
// ./src/users/resource/notFound.html
// module id = 263
// module chunks = 0